import { css } from "styled-components"

export const SwiperStyle = css`
  .swiper {
    width: 100%;
    height: auto !important;  /* add !important */

    .swiper-wrapper {
      align-items: center;
      height: auto !important;
    }
  }
`

export const SliderStyle = css`
  .swiper-slide {           /* all slides, not just active */
    height: auto !important;
    display: flex !important;
    align-items: center;
    justify-content: center;
  }
`